// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaFilterBase, CriteriaFilterBaseSchema } from 'api/gen/CriteriaFilterBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';

const requiredPart = t.interface({
  tag: t.literal('DATE'),
  leftValue: t.union([DateSchema, t.null]),
  rightValue: t.union([DateSchema, t.null]),
});

export const CriteriaDateFilterSchema = excess(t.intersection([CriteriaFilterBaseSchema.type, requiredPart]));

export interface CriteriaDateFilter extends t.TypeOf<typeof CriteriaDateFilterSchema> {}
